module.exports = "<div class=\"wrapperMDI\">\r\n  <div class=\"activeProgram\">\r\n    <div class=\"titleMDI\">ActiveProgram</div>\r\n    <div class=\"item1\">1</div>\r\n    <div class=\"item1\">2</div>\r\n    <div class=\"item1\">3</div>\r\n  </div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/StartApp/welcome/start/simulator/panel-wrapper/mem/wrapper-panels/mdi/mdi.component.html
// module id = ./src/app/StartApp/welcome/start/simulator/panel-wrapper/mem/wrapper-panels/mdi/mdi.component.html
// module chunks = main